import React from "react";
import SideArtistTerms from "./sideArtist";
import ProducerTerms from "./producerTerms";
import formValidation from "utils/validations";
import MusicVideo from "./musicVideo";
import Publishing from "./publishing";
import Remix from "./remix";
import ArtWork from "./artWork";

const Terms = ({
  data,
  setData,
  producerData,
  setProducerData,
  sideArtistData,
  setSideArtistData,
  publishingData,
  setPublishingData,
  musicVideoData,
  setMusicVideoData,
  artworkData,
  setArtworkData,
  remixData,
  setRemixData,
  contractData,
  onSideArtistSubmit,
  onArtworkSubmit
}) => {
  const renderTerms = () => {
    switch (data?.agreementType || contractData?.payload?.agreementType) {
      case "Side Artist Agreement":
        return (
          <SideArtistTerms data={sideArtistData} setData={setSideArtistData} onSideArtistSubmit = {onSideArtistSubmit}/>
        );
      case "Producer Agreement":
        return <ProducerTerms data={producerData} setData={setProducerData} />;
      case "Artwork Agreement":
        return <ArtWork data={artworkData} setData={setArtworkData} onArtworkSubmit={onArtworkSubmit}/>;
      case "Music Video Agreement":
        return <MusicVideo data={musicVideoData} setData={setMusicVideoData} />;
      case "Remix Agreement":
        return <Remix data={remixData} setData={setRemixData} />;
      case "Publishing Split Form":
        return <Publishing data={publishingData} setData={setPublishingData} />;
      default:
        return null;
    }
  };

  return <>{renderTerms()}</>;
};

export default Terms;
